import Account from "callable-data-objects/dist/models/account/Account";
import Page from "callable-data-objects/dist/services/Page";
import { access } from "fs";
import useCheckRole from "Hooks/APICheckRole";
import React from "react";
import { Button, Container, Label, Table } from "semantic-ui-react";

type AccountListProps = {
  accounts: Page<Account>;
  select: Function;
};

const AccountList = ({ accounts, select }: AccountListProps) => {
  const { hasRole, roles } = useCheckRole();
  const canSelect = hasRole(roles.account.roles.select);
  const { content } = accounts;
  return (
    <Container fluid style={{ padding: "20px" }}>
      {renderTable(content, select, canSelect)}
    </Container>
  );
};

const renderTable = (
  content: Account[],
  select: Function,
  canSelect: Boolean
) => {
  const getVersionLabel = (acc: any) => {
    const version = acc?.type === '2.1' ? "v2.1" : acc?.settings?.find((s:any) => s.key === "CallableVersion")?.value === "V2" ? "V2" : "V1";
    const color = version === "v2.1" ? "pink" : version === "V2" ? "green" : "grey";    
    return <Label color={color}>{version}</Label>;
  };

  const getNameLabel = (acc: any) => {
    const canShow = canSelect && (acc.type !== '2.1' || acc.id === "5c9288af7fce9b04d428c6d4");
    if(canShow) return <a href='#' onClick={() => select(acc.id)}>{acc.name}</a>
    else return acc.name;
  }

  return (
    <Table celled padded stackable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={3}>Name</Table.HeaderCell>
          <Table.HeaderCell width={3}>Organisation</Table.HeaderCell>
          <Table.HeaderCell width={2}>MBN</Table.HeaderCell>
          <Table.HeaderCell width={2}>Domain</Table.HeaderCell>
          <Table.HeaderCell width={1}>Device Count</Table.HeaderCell>
          <Table.HeaderCell width={1}>Version</Table.HeaderCell>
          {canSelect && <Table.HeaderCell width={1}>Actions</Table.HeaderCell>}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {content &&
          content.map((acc: any) => (
            <Table.Row key={`tr-ddi-${acc.id}`}>
              <Table.Cell>{getNameLabel(acc)}
              </Table.Cell>
              <Table.Cell>{acc.organisation?.name}</Table.Cell>
              <Table.Cell>{acc.mbn}</Table.Cell>
              <Table.Cell>{acc.domain}</Table.Cell>
              <Table.Cell>
                <Label color='blue'>{acc.devices.length}</Label>
              </Table.Cell>
              <Table.Cell>{getVersionLabel(acc)}</Table.Cell>
              {canSelect && acc.type !== '2.1' && (
                <Table.Cell textAlign='left'>
                  <Button primary size='tiny' onClick={() => select(acc.id)}>
                    Select
                  </Button>
                </Table.Cell>
              )}
            </Table.Row>
          ))}
      </Table.Body>
    </Table>
  );
};

export default AccountList;
